import { GenericTableRow } from '@features/reports/utils/buildTableData'
import { BalanceSheetTableBalance } from '@features/reports/views/NL/balanceSheetReport/types/tableTypes'

import { useReportsPdfDocument } from '../../../../contexts/reportsPdfDocumentContext'
import { ReportsPdfTableBalanceCell } from '../ReportsPdfTableBalanceCell'

interface BalanceSheetBalanceCellProps {
  row: GenericTableRow<BalanceSheetTableBalance>
}

export const BalanceSheetBalanceCell = ({ row }: BalanceSheetBalanceCellProps) => {
  const { periods } = useReportsPdfDocument()

  return periods?.map((period) => {
    const balance = row.balances.find((balance) => balance.period === period.key)?.balance || 0

    return <ReportsPdfTableBalanceCell key={period.key} balance={balance} rowType={row.type} />
  })
}
